import * as React from 'react';
import { JobPosting } from '../../services/job-search-service';
import JobSummary, { JobSummaryDispatch } from './JobSummary';
import IndeedAttribution from './IndeedAttribution';
import SwipeableItem from '../Swipeable';

interface JobListState {
    jobs: JobPosting[];
    selectedJob?: string;
    dispatch: JobSummaryDispatch;
}

export default function JobList({jobs, selectedJob, dispatch}: JobListState) {
    const attribution = jobs.length ? <IndeedAttribution/> : null;

    // TODO: animate re-ordering - https://github.com/aholachek/react-flip-toolkit
    return (
        <React.Fragment>
            {jobs.map(job =>
                <SwipeableItem
                    key={job.id}
                    data={job}
                    selected={job.id === selectedJob}
                    dispatch={dispatch}
                >
                    <JobSummary
                        job={job}
                        dispatch={dispatch}
                    />
                </SwipeableItem>
            ) as any[]}
            {attribution}
        </React.Fragment>
    );
}
